// extracted by mini-css-extract-plugin
module.exports = {"input":"InputField_input__3KpRT","label":"InputField_label__1aXcd"};